import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { useMediaQuery } from 'academy-common-lib/utils/Styling';
import RouterDropdownFilter, { RouterFilterTags, StyledTagsContainer } from '../../../containers/TracksPage/RouterDropdownFilter';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { isSearchFilter, isSortFilter } from '../filtersUtils';
import { useGuardFilterParams, useSearchFilter, useSortFilter } from '../filtersHooks';
import { useMemo } from 'react';
import { RouterSearchInput } from '../../../features/filters/components/RouterSearchInput';
import { RouterSelectSingle } from '../../../features/filters/components/RouterSelectSingle';
import { View } from 'foundations-components/transitional/components/View';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RouterSelectSingleStyled = styled(RouterSelectSingle).withConfig({
  displayName: "TopFilters__RouterSelectSingleStyled",
  componentId: "vobqir-0"
})(["&&{overflow:visible;}"]);
export const TopFilters = ({
  enabledFilters,
  showLabel = true,
  showTags = true
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const searchFilter = useSearchFilter(enabledFilters);
  const sortFilterType = useSortFilter(enabledFilters);
  useGuardFilterParams();
  const dropdownFilters = useMemo(() => {
    return enabledFilters.map(filter => {
      if (isSearchFilter(filter) || isSortFilter(filter)) return null;
      switch (filter) {
        case FILTER_TYPES.ASSIGNED_BY:
          return /*#__PURE__*/_jsx(InlineLabel, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.topFilters.${filter}.filterTitle`
            }),
            children: /*#__PURE__*/_jsx(RouterSelectSingle, {
              filterType: filter
            })
          });
        case FILTER_TYPES.CREATED_BY:
        case FILTER_TYPES.LANGUAGE:
        case FILTER_TYPES.PROGRESS_STATUS:
          return /*#__PURE__*/_jsx(RouterSelectSingle, {
            filterType: filter,
            retainSelection: false,
            valueRenderer: () => /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.topFilters.${filter}.filterTitle`
            })
          });
        case FILTER_TYPES.CONTENT_TYPE:
          return /*#__PURE__*/_jsx(RouterDropdownFilter, {
            filterType: filter
          }, `top-filter-${filter}`);
        default:
          return /*#__PURE__*/_jsx(RouterDropdownFilter, {
            filterType: filter
          }, `top-filter-${filter}`);
      }
    }).filter(Boolean);
  }, [enabledFilters]);
  const sortFilter = useMemo(() => {
    return sortFilterType ? /*#__PURE__*/_jsx(InlineLabel, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${sortFilterType}.filterTitle`
        }), ":"]
      }),
      children: /*#__PURE__*/_jsx(RouterSelectSingleStyled, {
        filterType: sortFilterType,
        menuWidth: 270
      })
    }) : null;
  }, [sortFilterType]);
  const showSearchOnLeft = !dropdownFilters.length && !sortFilter && searchFilter;
  const showSortFilterOnLeft = !!sortFilter && !dropdownFilters.length;
  return isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      marginBlockStart: "-500",
      marginInlineStart: "-300",
      position: "relative",
      children: /*#__PURE__*/_jsx(StyledTagsContainer, {
        children: enabledFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
          filterType: filter
        }, filter))
      })
    }), searchFilter && /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "500",
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(RouterSearchInput, {
        filterType: searchFilter
      })
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FilterBar, {
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [sortFilterType && !showSortFilterOnLeft && sortFilter, !showSearchOnLeft && searchFilter && /*#__PURE__*/_jsx(RouterSearchInput, {
          filterType: searchFilter
        })]
      }),
      marginBlockEnd: "400",
      marginBlockStart: "0",
      startSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [showLabel && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), dropdownFilters.length ? dropdownFilters : showSearchOnLeft && /*#__PURE__*/_jsx(RouterSearchInput, {
          filterType: searchFilter
        }), showSortFilterOnLeft && sortFilter]
      })
    }), /*#__PURE__*/_jsx(StyledTagsContainer, {
      children: showTags && enabledFilters.map(filter => !isSearchFilter(filter) && /*#__PURE__*/_jsx(RouterFilterTags, {
        filterType: filter
      }, filter))
    })]
  });
};
export default TopFilters;